var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoctailGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4349 1.44139C21.6768 1.19955 21.7485 0.836739 21.6179 0.520949C21.487 0.20555 21.1792 -0.00012207 20.838 -0.00012207H1.16188C0.820232 -0.00012207 0.512409 0.20555 0.381958 0.520949C0.250871 0.836739 0.323062 1.19955 0.564902 1.44139L10.1556 11.0312V20.5901L4.59793 23.2851C4.4408 23.3621 4.35648 23.5373 4.39603 23.7077C4.43508 23.879 4.58689 23.9999 4.76211 23.9999H17.2378C17.413 23.9999 17.5646 23.879 17.6034 23.7077C17.6434 23.5373 17.5591 23.3621 17.4015 23.2851L11.8443 20.5901V11.0312L21.4349 1.44139ZM18.7995 1.68831L16.5843 3.90353C14.6469 3.57714 13.0313 4.60994 11.2579 5.05462C9.28498 5.54935 7.10285 3.8309 5.12375 3.61179L3.19987 1.68831H18.7995Z",
    fill: "#F2EADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoctailGlass);
export default __webpack_public_path__ + "static/media/coctail-glass.e7c6ad402c7b7e9418633ef1491c10f2.svg";
export { ForwardRef as ReactComponent };